/* eslint-disable no-console */
import { useCallback, useState } from 'react';
import { useApolloClient } from '@apollo/react-hooks';
import SessionQuery from 'src/queries/SessionQuery';
import SessionObject from './session';
import checIntallation from './checkInstallation';

export { SessionObject };

export default () => {
  const [currentSession, setCurrentSession] = useState(null);
  const client = useApolloClient();

  const fetchCurrentSession = useCallback(
    async (sessionId) => {
      try {
        const session = await client.query({
          query: SessionQuery,
          variables: {
            sessionId,
          },
        });
        return session;
      } catch (err) {
        return { data: { session: null } };
      }
    },
    [client]
  );

  const updateSession = useCallback((props) => {
    Object.keys(props).forEach((key) => {
      SessionObject[key] = props[key];
    });
  }, []);

  const resetSession = () => {
    SessionObject.hasOldSession = null;
    SessionObject.tenant = null;
    SessionObject.session = null;
    setCurrentSession(SessionObject);
  };

  const configureApp = useCallback(
    // eslint-disable-next-line consistent-return
    async (shop) => {
      try {
        const installation = await checIntallation(shop);
        if (installation.callbackURL) {
          return {
            callbackURL: installation.callbackURL,
          };
        }

        SessionObject.shop = installation.shop;

        let sessionId;
        if (SessionObject.hasOldSession) {
          sessionId = SessionObject.hasOldSession;
        } else {
          sessionId = SessionObject.session ? SessionObject.session.id : null;
        }

        if (!sessionId) {
          resetSession();
          return {
            redirect: '/auth/signin',
          };
        }

        const {
          data: { session },
        } = await fetchCurrentSession(sessionId);

        if (!session) {
          resetSession();
          return {
            redirect: '/auth/signin',
          };
        }

        const { tenant, ...newSession } = session;
        SessionObject.tenant = tenant;
        SessionObject.session = newSession;

        setCurrentSession(SessionObject);

        if (SessionObject.hasOldSession) {
          SessionObject.hasOldSession = null;
          return {
            redirect: tenant ? '/sessionexpired' : '/auth/signin',
          };
        }

        return {};
      } catch (err) {
        console.log(err);
      }
    },
    [fetchCurrentSession]
  );

  return {
    configureApp,
    session: currentSession,
    updateSession,
  };
};
